import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=5c0937dd&scoped=true&"
import script from "./tv.js?vue&type=script&lang=js&"
export * from "./tv.js?vue&type=script&lang=js&"
import style0 from "./tv.css?vue&type=style&index=0&id=5c0937dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0937dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
